// extracted by mini-css-extract-plugin
export default {"container":"Y0BjOi","spacing":"JlD8hJ","table":"IWu4ZY","paginationSpacing":"f5kmSp","paginationContainer":"oWX3ZY","loader":"EUy8cI","topSeparator":"aHIk54"};